import React, { useRef } from 'react';

import { ContainerStyled } from './FocusInterceptor.styled';

type Props = { render: (interceptFocus: () => void) => React.ReactNode };

export default function FocusInterceptor({ render }: Props): JSX.Element {
  const focusInterceptorRef = useRef<React.ElementRef<'div'>>();

  const interceptFocus = () => {
    focusInterceptorRef.current?.focus();
  };

  return (
    <ContainerStyled
      tabIndex={-1}
      innerRef={focusInterceptorRef}
      data-testid='focus-interceptor'
    >
      {render(interceptFocus)}
    </ContainerStyled>
  );
}
